import { IExtraJob, IExtraJobWithQuiz, IQuizResultDetail } from '../../..';

export enum ExtraJobStatus {
    VERIFIED_BY_ADMIN = 'validated_by_admin',
    QUIZ_NOT_FOUND = 'quiz_not_found',
    QUIZ_WAITING_COMPLETION = 'quiz_waiting_completion',
    QUIZ_SUCCEED = 'quiz_succeed',
    QUIZ_FAILED = 'quiz_failed',
}

function getJobsWithQuiz(
    jobs: IExtraJob[],
    completedQuizzes: IQuizResultDetail[],
    availableQuizzes: number[]
): IExtraJobWithQuiz[] {
    return jobs.map((job: IExtraJob): IExtraJobWithQuiz => {
        const jobWithQuiz: IExtraJobWithQuiz = { ...job };
        if (job.verifiedByAdmin) {
            jobWithQuiz.status = ExtraJobStatus.VERIFIED_BY_ADMIN;
            return jobWithQuiz;
        }

        jobWithQuiz.status =
            availableQuizzes.indexOf(job.jobId) >= 0
                ? ExtraJobStatus.QUIZ_WAITING_COMPLETION
                : ExtraJobStatus.QUIZ_NOT_FOUND;

        const quizForJob = completedQuizzes.find((quiz) => quiz.jobId === job.jobId);
        if (!quizForJob) {
            return jobWithQuiz;
        }

        if (quizForJob.isSuccess) {
            jobWithQuiz.status = ExtraJobStatus.QUIZ_SUCCEED;
            return jobWithQuiz;
        }

        jobWithQuiz.quizNextAvailableTryAt = quizForJob.nextAvailableTryAt;
        if (quizForJob.nextAvailableTryAt && new Date(quizForJob.nextAvailableTryAt) >= new Date()) {
            jobWithQuiz.status = ExtraJobStatus.QUIZ_FAILED;
        }

        return jobWithQuiz;
    });
}

export type ExtraJobsReturn = {
    getJobsWithQuiz: (
        jobs: IExtraJob[],
        completedQuizzes: IQuizResultDetail[],
        availableQuizzes: number[]
    ) => IExtraJobWithQuiz[];
};

export const extra = (): ExtraJobsReturn => {
    return {
        getJobsWithQuiz,
    };
};
